const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import ECheckinForm from 'App/config/zgks/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/zgks/Footer';
import textMap from './translations';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.zgks.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beziehung: 'Lookup/e2c80c9b-7a0f-463d-96a2-d877b8cf88b9/Children',
        Anrede: 'Lookup/70ee8bde-a00f-43c2-951e-5fb6671f9b2c/Children',
        Geschlecht: 'Lookup/27618816-eae9-4b2a-b834-8f2a9ffe8081/Children',
        Zivilstand: 'Lookup/4732b58b-b4eb-4860-af52-e4dcdffdd757/Children',
        Behandlungsgrund: 'Lookup/fe9dcbfe-47be-4a14-8be5-6ca98103b919/Children',
        Versicherung: 'Lookup/da6c9c95-92d8-46e2-bdcb-c98ea978e4c6/Children',
        Klasse: 'Lookup/b2c9ed8c-6c36-411c-a676-accca165ab85/Children',
        Religion: 'Lookup/fa6f3a3e-1d57-43ff-882c-5167e7ab9833/Children',
        YN: 'Lookup/27a3b71c-9be7-41aa-8976-0de73e66a454/Children',
    },
    customMatomoClientId: 4,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryAppointmentDeadline: undefined,
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
